type Enumerate<N extends number, Acc extends number[] = []> = Acc['length'] extends N
  ? Acc[number]
  : Enumerate<N, [...Acc, Acc['length']]>;

export type NumberRange<F extends number, T extends number> = Exclude<Enumerate<T>, Enumerate<F>>;

type timeRange = NumberRange<1, 61>;
type timeRestrictionRange = {
  fromMinutes: number;
  toMinutes: number;
};

export const getTimeRanges = (interval: timeRange, timeRestriction?: timeRestrictionRange) => {
  const ranges = [];
  const date = new Date();
  const fromMinutes = timeRestriction ? timeRestriction.fromMinutes : 0;
  const toMinutes = timeRestriction ? timeRestriction.toMinutes : 24 * 60;

  for (let minutes = fromMinutes; minutes < toMinutes; minutes += interval) {
    date.setHours(0);
    date.setMinutes(minutes);
    const formattedTime = date
      .toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
      .toLowerCase()
      .replace(/\s/g, '');

    ranges.push(formattedTime);
  }

  return ranges;
};

export const addSpaceToSchedule = (time: string) => {
  return `${time.slice(0, 5)} ${time.slice(-2)}`;
};

const TIME_RANGE = 30;

export function getTimeRangeOptions(timeRange: timeRange = TIME_RANGE) {
  return getTimeRanges(timeRange).map((time) => ({
    text: addSpaceToSchedule(time),
    id: time,
  }));
}

export const convertTo24 = (time: string) => {
  const timeArr = time.split(':');
  let hours = timeArr[0];
  let minutes = timeArr[1].slice(0, 2);
  let modifier = timeArr[1].slice(2);

  if (hours === '12') {
    hours = '00';
  }

  if (modifier.toLowerCase() === 'pm') {
    hours = `${parseInt(hours, 10) + 12}`;
  }

  return { hours: Number(hours), minutes: Number(minutes) };
};

type HoursMinutes = {
  minutes: number;
  hours: number;
};

export const getMinutesFromDate = (time: HoursMinutes) => {
  if (time.hours === 23 && time.minutes === 60) {
    return 1440;
  }

  const date = new Date();

  date.setHours(time.hours, time.minutes);
  const hoursInMinutes = date.getHours() * 60;

  return hoursInMinutes + date.getMinutes();
};
